import handler from "../health/responseHandler";

export const fetchRetry = async (
      input: RequestInfo, 
      options?: RequestInit, 
      ignore401: boolean = false,
      retries = 3,
      backoff = 300, 
      retryCodes?: number[],
      )
  : Promise<Response>  => {
  
    const codes = retryCodes || [408, 500, 502, 503, 504, 522, 524];
  
    const r = await fetch(input, options);
    if (r.ok) {
      return r;
    }

    if (retries <= 0) {
      return handler.onError(r);
    }

    if (codes.includes(r.status)) {
      setTimeout(() => {
        return fetchRetry(input, options,ignore401, retries - 1, backoff * 2);
      }, backoff);
    } 
    if (!ignore401 && r.status === 401) {
        window.location.reload();

        return fetchRetry(input, options, ignore401, retries - 1, 1000 + backoff * 2);
    }

    return handler.onError(r);
}
